var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "900",
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_vm.isLoaded ? _c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', [_vm.isCreate ? [_vm._v("프로그램 생성")] : [_vm._v("프로그램 상세")], _c('v-spacer'), _c('v-icon', {
    on: {
      "click": function ($event) {
        _vm.shows = false;
      }
    }
  }, [_vm._v("mdi-close")])], 2), _c('v-divider'), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "5"
    }
  }, [_c('v-card-subtitle', [_vm._v("썸네일")]), _c('v-divider'), _c('v-card-text', [_c('v-preview-input', {
    attrs: {
      "aspect-ratio": 1 / 1
    },
    model: {
      value: _vm.inputs.thumb,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "thumb", $$v);
      },
      expression: "inputs.thumb"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('v-divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMobile,
      expression: "!isMobile"
    }],
    attrs: {
      "vertical": ""
    }
  }), _c('v-divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isMobile,
      expression: "isMobile"
    }]
  })], 1), _c('v-col', [_c('v-card-subtitle', [_vm._v("기본 정보")]), _c('v-divider'), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-select', _vm._b({
    attrs: {
      "label": "유형",
      "items": _vm.items_hall
    },
    model: {
      value: _vm.inputs.hall,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "hall", $$v);
      },
      expression: "inputs.hall"
    }
  }, 'v-select', _vm.attrs_input, false))], 1), _c('v-col')], 1), _c('v-text-field', _vm._b({
    staticClass: "my-3",
    attrs: {
      "label": "프로그램 제목"
    },
    model: {
      value: _vm.inputs.subject,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "subject", $$v);
      },
      expression: "inputs.subject"
    }
  }, 'v-text-field', _vm.attrs_input, false)), _c('row-date-time', {
    attrs: {
      "label": "일시",
      "attrs_input": _vm.attrs_input
    },
    model: {
      value: _vm.inputs.at,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "at", $$v);
      },
      expression: "inputs.at"
    }
  }), _c('row-date-time', {
    attrs: {
      "label": "기간-시작",
      "attrs_input": _vm.attrs_input
    },
    model: {
      value: _vm.inputs.duration.startsAt,
      callback: function ($$v) {
        _vm.$set(_vm.inputs.duration, "startsAt", $$v);
      },
      expression: "inputs.duration.startsAt"
    }
  }), _c('row-date-time', {
    attrs: {
      "label": "기간-종료",
      "attrs_input": _vm.attrs_input
    },
    model: {
      value: _vm.inputs.duration.endsAt,
      callback: function ($$v) {
        _vm.$set(_vm.inputs.duration, "endsAt", $$v);
      },
      expression: "inputs.duration.endsAt"
    }
  }), _c('v-text-field', _vm._b({
    staticClass: "my-3",
    attrs: {
      "label": "장소"
    },
    model: {
      value: _vm.inputs.location,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "location", $$v);
      },
      expression: "inputs.location"
    }
  }, 'v-text-field', _vm.attrs_input, false)), _c('v-combobox', _vm._b({
    attrs: {
      "label": "그룹",
      "placeholder": "Tab을 누르면 항목이 추가됩니다",
      "multiple": "",
      "small-chips": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref2) {
        var attrs = _ref2.attrs,
          item = _ref2.item,
          parent = _ref2.parent;
        return [_c('v-chip', _vm._b({
          attrs: {
            "small": "",
            "text-color": "grey darken-4"
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v(" " + _vm._s(item) + " ")]), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function ($event) {
              return parent.selectItem(item);
            }
          }
        }, [_vm._v(" $delete ")])], 1)];
      }
    }], null, false, 2690560794),
    model: {
      value: _vm.inputs.groups,
      callback: function ($$v) {
        _vm.$set(_vm.inputs, "groups", $$v);
      },
      expression: "inputs.groups"
    }
  }, 'v-combobox', _vm.attrs_input, false))], 1)], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" 저장하기 ")])], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }